function validate_name_with_rfc(rfc , name, paternal_name , maternal_name ){
        const vowels = ["a", "e", "i", "o", "u"];
        const restrictNames = ["maria", "jose"];
        const restrictLetter = "ñ";

        const rfcLowerCase = removeAccents(rfc).toLocaleLowerCase();
        const nameLowerCase = removeAccents(name).toLocaleLowerCase();
        let paternalNameLowerCase = removeAccents(paternal_name).toLocaleLowerCase();
        let maternalNameLowerCase = removeAccents(maternal_name).toLocaleLowerCase();
        let paternalLastNameEmpty = false;
        let maternalLastNameEmpty = false;

        if(paternalNameLowerCase.length == 0){
            paternalLastNameEmpty = true;
            paternalNameLowerCase = maternalNameLowerCase
        }
        if(maternalNameLowerCase.length == 0){
            maternalLastNameEmpty = true;
        }
        console.log("outside: ", paternalLastNameEmpty)

        
        const nameSplit = nameLowerCase.split(" ");
        console.log("nameSplit: ", nameSplit)
        let firstName = nameSplit[0]
        console.log("nameSplit: ", firstName)

        if(restrictNames.includes(firstName)){
            const lastMiddleName = nameSplit[nameSplit.length - 1]
            firstName = lastMiddleName;
        }
        
        let firtsPaternalLetter = paternalNameLowerCase.slice(0,1);
        console.log("firtsPaternalLetter: ", firtsPaternalLetter)
        if(firtsPaternalLetter === restrictLetter){
            firtsPaternalLetter = "x"
        }   

        const splitPaternalName = paternalNameLowerCase.split("")
        console.log("splitPaternalName: ", splitPaternalName)
        splitPaternalName.shift();

        let letter = "" 
        for(const vowel of splitPaternalName){
            if(vowels.includes(vowel)){
                letter = vowel;
                break;
            }
        }

        const paternal = firtsPaternalLetter + letter;
        let composeRfc = "";
        if(paternalLastNameEmpty){
            composeRfc = paternal + firstName.slice(0,2);
        }else{
            composeRfc = paternal + maternalNameLowerCase.slice(0,1) + firstName.slice(0,1);
        }
        
        if(maternalLastNameEmpty){
            composeRfc = paternal + firstName.slice(0,2);
        }

        const slice_rfc = rfcLowerCase.slice(0, 4);
        console.log("composeRfc", composeRfc)
        console.log("slice_rfc", slice_rfc)
        
        if(slice_rfc === composeRfc){
            return true;
        }
        return false;
    }

function removeAccents(str){
    console.log("STR: ", str)
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export {
    validate_name_with_rfc
}